import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useMemo } from "react";
import { get } from "../../utils/storage";
export var ABFlagsContext = /*#__PURE__*/ createContext({
    subscribe: function() {}
});
export function ABFlagsProvider(param) {
    var children = param.children;
    var value = useMemo(function() {
        return {
            subscribe: function(flag, callback) {
                var handleFlagSet = function() {
                    callback(get(flag));
                };
                var handleStorage = function(event) {
                    if (event.key === flag) {
                        callback(get(flag));
                    }
                };
                document.addEventListener("" + flag + "Set", handleFlagSet);
                window.addEventListener("storage", handleStorage);
                return function() {
                    document.removeEventListener("" + flag + "Set", handleFlagSet);
                    window.removeEventListener("storage", handleStorage);
                };
            }
        };
    }, []);
    return /*#__PURE__*/ _jsx(ABFlagsContext.Provider, {
        value: value,
        children: children
    });
}

//# sourceMappingURL=ABFlagsProvider.js.map